module.exports = __webpack_public_path__ + "static/ing-design-11158a780d8d1e11b2a21da5684da25e.png";